var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminApiTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0714 9.66667V15.7778H8.92857V9.66667H14.0714ZM13.1071 6H9.89286L9.25 6.61111H7V7.83333H16V6.61111H13.75L13.1071 6ZM15.3571 8.44444H7.64286V15.7778C7.64286 16.45 8.22143 17 8.92857 17H14.0714C14.7786 17 15.3571 16.45 15.3571 15.7778V8.44444Z",
    fill: "var(--fill-0, #FF3152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 21.62V23H4.6V21.62H18.4ZM21.62 18.4V4.6C21.62 2.82164 20.1784 1.38 18.4 1.38H4.6C2.82164 1.38 1.38 2.82164 1.38 4.6V18.4C1.38 20.1784 2.82164 21.62 4.6 21.62V23L4.36371 22.9937C2.01129 22.8747 0.125326 20.9887 0.00628906 18.6363L0 18.4V4.6C0 2.05949 2.05949 3.70447e-08 4.6 0H18.4C20.9405 0 23 2.05949 23 4.6V18.4C23 20.8613 21.067 22.8707 18.6363 22.9937L18.4 23V21.62C20.1784 21.62 21.62 20.1784 21.62 18.4Z",
    fill: "var(--fill-0, #FF3152)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminApiTrashIcon);
export default __webpack_public_path__ + "static/media/AdminApiTrashIcon.2bc3d47cad9b4ffe447bae62de0851da.svg";
export { ForwardRef as ReactComponent };